module.exports = __webpack_public_path__ + "img/1519589616.a24d1c56.jpg";